import { Shield, Eye, Lightbulb, Sprout } from "lucide-react";

const CoreValues = () => {
    const values = [
        {
            Icon: Shield,
            title: "Integrity",
            description:
                "We do the right thing — always. Ethical AI development and transparent business practices are our foundation.",
        },
        {
            Icon: Eye,
            title: "Transparency",
            description:
                "Clear communication and openness in every engagement. You'll always know how our systems work.",
        },
        {
            Icon: Lightbulb,
            title: "Innovation",
            description:
                "We embrace hard problems and take smart risks to uncover new possibilities.",
        },
        {
            Icon: Sprout,
            title: "Pay It Forward",
            description:
                "Investing in the community and future AI talent through education, training, and opportunity for all.",
        },
    ];

    return (
        <section className="relative py-32 border-t border-white/5">
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
                    <div className="lg:col-span-5">
                        <div className="sticky top-32">
                            <div className="text-[11px] font-mono uppercase tracking-widest text-accent-brand mb-4">
                                / Operating Principles
                            </div>
                            <h2 className="text-5xl md:text-6xl font-display leading-[0.95] tracking-tight text-white mb-6">
                                Our <em className="italic text-white/50">values</em> are
                                <br />
                                also our
                                <br />
                                <em className="italic">contract.</em>
                            </h2>
                            <p className="text-white/60 text-[15px] leading-relaxed max-w-md">
                                To remove barriers and uncover new possibilities in technology through AI automation — finding simple solutions to complex problems.
                            </p>
                        </div>
                    </div>

                    <div className="lg:col-span-7 space-y-px bg-white/5 rounded-2xl overflow-hidden border border-white/10">
                        {values.map((v, i) => (
                            <div
                                key={i}
                                className="bg-ink-950 hover:bg-ink-900 p-8 md:p-10 transition-colors"
                                data-testid={`value-card-${i}`}
                            >
                                <div className="flex items-start gap-6">
                                    <div className="flex-shrink-0 w-11 h-11 rounded-lg bg-accent-brand/10 border border-accent-brand/20 flex items-center justify-center">
                                        <v.Icon className="w-5 h-5 text-accent-brand" strokeWidth={1.5} />
                                    </div>
                                    <div className="flex-1">
                                        <div className="flex items-center justify-between mb-3">
                                            <h3 className="text-2xl md:text-3xl font-display text-white tracking-tight">
                                                {v.title}
                                            </h3>
                                            <span className="text-[11px] font-mono text-white/30">0{i + 1}</span>
                                        </div>
                                        <p className="text-white/60 text-[15px] leading-relaxed">
                                            {v.description}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CoreValues;
